import { Box, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import sigliveEmpty from 'Asset/image/siglive-empty-state.svg';
import { TextBold, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const EmptyActiveOperators = () => {
  const { t } = useTranslation('dashboard');
  return (
    <Box className={styles['active-operators__container']}>
      <Image src={sigliveEmpty} alt="siglive-empty" />
      <Box className={styles['active-operators__empty-text']}>
        <TextBold className={styles['active-operators__empty-title']}>{t('activeOperatorsView.emptyTitle')}</TextBold>
        <TextRegular className={styles['active-operators__empty-desc']}>{t('activeOperatorsView.emptyDescription')}</TextRegular>
      </Box>
    </Box>
  );
};

export default EmptyActiveOperators;